/* src/app/dashboard/ui/components/toolbar/download-dialog/download-dialog.component.scss */
.download-dialog {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 1.75em 2em 1em;
  max-width: 90vw;
  max-height: 90dvh;
  overflow-y: auto;
}
.download-dialog-header {
  margin-bottom: 1.5em;
  padding-bottom: 0.8em;
}
.download-dialog-header h2 {
  color: #333;
  font-size: 1.4em;
  font-weight: 600;
  margin: 0;
}
section {
  margin-bottom: 3em;
}
section:last-child {
  margin-bottom: 1em;
}
section h4 {
  color: #555;
  font-size: 1.1em;
  margin-bottom: 0.8em;
  font-weight: 500;
}
section .duration {
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #555;
  display: inline-block;
  font-size: 0.95em;
  margin: 0;
  padding: 0.5em 1em;
}
.download-data {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.download-data li {
  align-items: center;
  display: flex;
  padding: 0.375em 0;
}
.download-data li:first-child {
  border-bottom: 1px solid #e0e0e0;
  font-weight: 500;
  margin-bottom: 0.5em;
  padding-bottom: 0.8em;
}
.download-data li label {
  margin-left: 0.5em;
  cursor: pointer;
}
.download-data li input[type=checkbox] {
  cursor: pointer;
}
.download-format {
  display: flex;
  align-items: center;
  margin-bottom: 0.8em;
}
.download-format label {
  margin-left: 0.5em;
  cursor: pointer;
}
.download-format input[type=radio] {
  cursor: pointer;
}
.download-dialog-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1em;
  margin-top: 2em;
}
.download-dialog-buttons button {
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  padding: 0.8em 1.5em;
  transition: background-color 0.2s, transform 0.1s;
}
.download-dialog-buttons button:hover {
  transform: translateY(-1px);
}
.download-dialog-buttons button:active {
  transform: translateY(1px);
}
.download-dialog-buttons .download-button {
  background-color: #4285f4;
  color: white;
}
.download-dialog-buttons .download-button:hover {
  background-color: #3b78e7;
}
.download-dialog-buttons .cancel-button {
  background-color: #f1f3f4;
  color: #5f6368;
}
.download-dialog-buttons .cancel-button:hover {
  background-color: #e8eaed;
}
/*# sourceMappingURL=download-dialog.component-RZ32GEFV.css.map */
